// Check if a value is a string
export function isString(value: unknown): value is string {
  return typeof value === 'string';
}

// Check if a value is a number
export function isNumber(value: unknown): value is number {
  return typeof value === 'number' && !isNaN(value);
}

// Check if a value is an object (but not null)
export function isObject(value: unknown): value is object {
  return typeof value === 'object' && value !== null;
}

export function withNonNullOrUndefined<T>(typeGuard: (value: unknown) => value is T) {
  return (value: unknown): value is T => value !== null && value !== undefined && typeGuard(value);
}

export const isNonNullString = withNonNullOrUndefined(isString);
export const isNonNullNumber = withNonNullOrUndefined(isNumber);
export const isNonNullObject = withNonNullOrUndefined(isObject);
